export default __webpack_public_path__ + "static/media/FPJM.51ddfa32.png";